import { MEMBERS_MAX, MEMBERS_MIN } from "@/lib/session-members";

/**
 * Broj iz polja "Najviše članova" kad je cijeli broj u dozvoljenom rasponu,
 * inače null: polje tada zadrži upisano dok terapeut ne završi kucanje, umjesto
 * da prazno polje skoči na 2 (pa "4" postane "24").
 */
export function maxMembersFromInput(raw: string): number | null {
  const text = raw.trim();
  if (!/^\d+$/.test(text)) return null;
  const n = Number(text);
  return n >= MEMBERS_MIN && n <= MEMBERS_MAX ? n : null;
}
